import React, { Component } from 'react';
import ReactToPrint, { PrintContextConsumer } from "react-to-print";


export default class DriverWageDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      data: props.data || null,
      fromDate:props.fromDate || null,
      toDate:props.toDate || null,
      title:props.title || null,
    }
  }

  handleAfterPrint = () => {
    $('.printDriverName').addClass('d-none');
  };

  handleCalculateWageButtonClicked() {
    this.calculateWage();
  }

  handleApproveWageButtonClicked() {
    this.approveWage();
  }

  handleSetWageAsPaidButtonClicked() {
    this.setWageAsPaid();
  }

  setComponentRef = (ref) => {
    this.componentRef = ref;
  };

  renderDriverInvoice = (ref) => {
    let BreakdownItems = [];
    var that = this;
    let finalTotal = 0;
    let totalPayble = 0;
    let expenseTotal = 0;
    let fuelTotal = 0;
    let taxiTotal = 0;
    let bonusTotal = 0;
    let tollTotal = 0;
    let otherTotal = 0;
    let costOfJobTotal = 0;
    let instpTotal = 0;
    let waitingTimeTotal = 0;
    let jobPriceTotal = 0;
    let driverInvoiceName = document.getElementById('driver-wage-details-modal-label').innerText;

    if (this.state.data.breakdown &&
      (this.state.data.breakdown.length > 0)) {

      let i = 0;
      let acvTotal = 0;
      let bvlTotal = 0;
      let g4Total = 0;
      let cndTotal = 0;
      let sccdTotal = 0;


      this.state.data.breakdown.forEach(function (breakdownItem) {

        expenseTotal = (breakdownItem.expenses != '') ? ((expenseTotal) + (parseFloat(breakdownItem.expenses))) : expenseTotal;
        fuelTotal = (breakdownItem.fuel != '') ? ((fuelTotal) + (parseFloat(breakdownItem.fuel))) : fuelTotal;
        taxiTotal = ((breakdownItem.taxi!=undefined) && (breakdownItem.taxi!==undefined) && (breakdownItem.taxi != '')) ? ((taxiTotal) + (parseFloat(breakdownItem.taxi))) : taxiTotal;
        bonusTotal = (breakdownItem.bonus != '') ? ((bonusTotal) + (parseFloat(breakdownItem.bonus))) : bonusTotal;
        if(isNaN(bonusTotal)){
          bonusTotal = 0.00
        }
        tollTotal = (breakdownItem.toll != '') ? ((tollTotal) + (parseFloat(breakdownItem.toll))) : tollTotal;
        otherTotal = (breakdownItem.other != '') ? ((otherTotal) + (parseFloat(breakdownItem.other))) : otherTotal;
        costOfJobTotal = (breakdownItem.cost_of_job != '') ? ((costOfJobTotal) + (parseFloat(breakdownItem.cost_of_job))) : costOfJobTotal;
        instpTotal = (breakdownItem.ins_tp) ? ((instpTotal) + (parseFloat(breakdownItem.ins_tp))) : instpTotal;

        waitingTimeTotal = (breakdownItem.waiting_time) ? ((waitingTimeTotal) + (parseFloat(breakdownItem.waiting_time))) : waitingTimeTotal;

        jobPriceTotal = (breakdownItem.job_price != '') ? ((jobPriceTotal) + (parseFloat(breakdownItem.job_price))) : jobPriceTotal;

        if (breakdownItem.category == "debit") {
          finalTotal = (finalTotal) - (parseFloat(breakdownItem.formatted_currency_string));
        } else {
          finalTotal = (finalTotal) + (parseFloat(breakdownItem.formatted_currency_string));
        }
        
        BreakdownItems.push(<tr key={that.state.data.id + '-' + i++} className="wages-cell-border">
          <td>{breakdownItem.date}</td>
          <td>{breakdownItem.type}</td>
          <td>{breakdownItem.category}</td>
          <td>{breakdownItem.customer}</td>
          <td>{breakdownItem.description}</td>
          <td>{breakdownItem.miles}</td>
          {/* <td>{breakdownItem.expenses}</td> */}
          <td>{breakdownItem.fuel}</td>
          <td>{breakdownItem.taxi}</td>
          <td>{breakdownItem.bonus}</td>
          <td>{breakdownItem.toll}</td>
          <td>{breakdownItem.other}</td>
          {/* <td>{breakdownItem.cost_of_job}</td> */}
          {/* <td>{breakdownItem.ins_tp}</td> */}
          {/* <td>{breakdownItem.job_price}</td> */}
          <td>{breakdownItem.waiting_time}</td>
          <td className={breakdownItem.type + '-debit'}>{breakdownItem.formatted_currency_string}</td>
          {/* <td>{(breakdownItem.driver_completed_at) ? moment(breakdownItem.driver_completed_at).format('D/MM/Y') : ''}</td> */}
        </tr>);
      });

      BreakdownItems.push(
        <tr key={that.state.data.id + '-' + i++}>
          <td colSpan="6"><strong>Total</strong></td>
          {/* <td>&pound;{(expenseTotal && expenseTotal != '') ? expenseTotal.toFixed(2) : 0.00}</td> */}
          <td>&pound;{(fuelTotal && fuelTotal != '') ? fuelTotal.toFixed(2) : 0.00}</td>
          <td>&pound;{(taxiTotal && taxiTotal != '') ? taxiTotal.toFixed(2) : 0.00}</td>
          <td>&pound;{(bonusTotal && bonusTotal != '') ? bonusTotal.toFixed(2) : 0.00}</td>
          <td>&pound;{(tollTotal && tollTotal != '') ? tollTotal.toFixed(2) : 0.00}</td>
          <td>&pound;{(otherTotal && otherTotal != '') ? otherTotal.toFixed(2) : 0.00}</td>
          {/* <td>&pound;{(costOfJobTotal && costOfJobTotal != '') ? costOfJobTotal.toFixed(2) : 0.00}</td> */}
          {/* <td>&pound;{(instpTotal && instpTotal != '') ? instpTotal.toFixed(2) : 0.00}</td> */}
          <td>&pound;{(waitingTimeTotal && waitingTimeTotal != '') ? waitingTimeTotal.toFixed(2) : 0.00}</td>
          {/* <td>&pound;{(jobPriceTotal && jobPriceTotal != '') ? jobPriceTotal.toFixed(2) : 0.00}</td> */}
          <td>&pound;{(finalTotal && finalTotal != '') ? finalTotal.toFixed(2) : 0.00}</td>
          {/* <td>&nbsp;</td> */}
        </tr>
      );
      finalTotal = finalTotal;
      totalPayble = ((finalTotal || 0) + (fuelTotal || 0) + (taxiTotal || 0) + (bonusTotal || 0) + (tollTotal || 0) + (otherTotal || 0) + (waitingTimeTotal || 0));
      this.handleTotalPayableToWages(totalPayble);
    }
    return (<div className="text-left" id={'driver-wage-' + this.state.data.id}>

      <div className="row">
        <div className="col-md-6">
          <button
            className="btn btn-lg btn-primary"
            onClick={(e) => { this.handleCalculateWageButtonClicked() }}
          >
            <i className="fa fa-calculator"></i> Calculate Wage
          </button>

          {/* <button className="btn btn-lg btn-primary ml-md-3" onClick={(e) => { window.print(); return false; }}>Print Page</button> */}
        </div>
      </div>

      {(this.state.data.calculated == 0) ?
        <p>Not calculated yet</p>
        :

        <div>

          {(this.state.data.breakdown && this.state.data.breakdown.length > 0) ?
            <div className="wage-details-calculated-wage-breakdown-container"  ref={ref}>
              <div className="row">
                <div className="col-md-12">
                  <center className="printDriverName d-none" id="printDriverName">{driverInvoiceName}</center>
                  <h1>Invoice</h1>
                  <div className="row">
                    <table className="driver-wages-tbl">
                      <thead>
                        <tr>
                          <th>date</th>
                          <th>type</th>
                          <th>category</th>
                          <th>customer</th>
                          <th>description</th>
                          <th>Miles</th>
                          {/* <th>Expenses</th> */}
                          <th>Fuel</th>
                          <th>Taxi</th>
                          <th>Bonus</th>
                          <th>Toll</th>
                          <th>Other</th>
                          {/* <th>Cost of Job</th> */}
                          {/* <th>INS-TP</th> */}
                          <th>Waiting Time</th>
                          {/* <th>Job Price</th> */}
                          <th>Driver Pay</th>
                          {/* <th>Driver completed date</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {BreakdownItems}
                      </tbody>
                    </table>
                  </div>
                  <h3 className="wage-total-payable-container">Driver pay:
                    <i className="fa fa-pound-sign"></i>
                    <span>
                      {finalTotal.toFixed(2).toString()}
                    </span>
                    <br />
                    {/* <div className="wage-total-payable-container">Expenses Payable: 
              <i className="fa fa-pound-sign"></i>
              <span>
                {(!isNaN(expenseTotal))?expenseTotal.toFixed(2).toString():0.00}
              </span>
            </div> */}
                    <br />
                    <div className="wage-total-payable-container">Fuel Payable:
                      <i className="fa fa-pound-sign"></i>
                      <span>
                        {(!isNaN(fuelTotal)) ? fuelTotal.toFixed(2).toString() : 0.00}
                      </span>
                    </div>
                    <br />
                    <div className="wage-total-payable-container">Taxi Payable:
                      <i className="fa fa-pound-sign"></i>
                      <span>
                        {(!isNaN(taxiTotal)) ? taxiTotal.toFixed(2).toString() : 0.00}
                      </span>
                    </div>
                    <br />
                    <div className="wage-total-payable-container">Bonus Payable:
                      <i className="fa fa-pound-sign"></i>
                      <span>
                        {(!isNaN(bonusTotal)) ? bonusTotal.toFixed(2).toString() : 0.00}
                      </span>
                    </div>
                    <br />
                    <div className="wage-total-payable-container">Toll Payable:
                      <i className="fa fa-pound-sign"></i>
                      <span>
                        {(!isNaN(tollTotal)) ? tollTotal.toFixed(2).toString() : 0.00}
                      </span>
                    </div>
                    <br />
                    <div className="wage-total-payable-container">Other Payable:
                      <i className="fa fa-pound-sign"></i>
                      <span>
                        {(!isNaN(otherTotal)) ? otherTotal.toFixed(2).toString() : 0.00}
                      </span>
                    </div>
                    <br />
                    <div className="wage-total-payable-container">Waiting Time Payable:
                      <i className="fa fa-pound-sign"></i>
                      <span>
                        {waitingTimeTotal.toFixed(2).toString()}
                      </span>
                    </div>
                  </h3>
                  <hr />
                  <h3 className="wage-total-payable-container">Total Payable:
                    <i className="fa fa-pound-sign"></i>
                    <span>
                      {(!isNaN(totalPayble)) ? totalPayble.toFixed(2).toString() : 0.00}
                    </span>
                  </h3>
                </div>
              </div>
            </div>
            :
            ''
          }

          <div className="row">
            <div className="col-md-4">
              <div className="wage-details-wage-approval-status-container">
                {(this.state.data.accountant_approved == 0) ?
                  <p>
                    This Invoice is not approved by an accountant.<br />
                    <button className="btn btn-lg btn-dark"
                      onClick={(e) => { this.handleApproveWageButtonClicked() }}>
                      <i className="fa fa-check"></i> Click to Approve
                    </button>
                  </p>
                  :
                  <button className="btn btn-lg btn-success">
                    <i className="fa fa-check"></i> Accountant Approved
                  </button>
                }
              </div>
            </div>
            <div className="col-md-4">
              <div className="wage-details-wage-approval-status-container">
                {(this.state.data.driver_approved == 0) ?
                  <p>
                    This Invoice is not approved by the driver.<br />
                    <button className="btn btn-lg btn-dark"
                      onClick={(e) => { this.handleDriverApproveWageButtonClicked() }}>
                      <i className="fa fa-check"></i> Click to Approve as Driver
                    </button>
                  </p>
                  :
                  <button className="btn btn-lg btn-success">
                    <i className="fa fa-check"></i> Driver Approved
                  </button>
                }
                {(this.state.data.admin_approved_as_driver != null) ?  <i className="fa fa-info-circle text-warning ml-1" data-toggle="tooltip" title="Force Upproved By Admin"></i> : ''}
                {(this.state.data.driver_not_approved_reason != null) ?
                  <span className="alert-danger reason-block">Declined Driver Reason : {this.state.data.driver_not_approved_reason}</span>
                  : null}
                {(this.state.data.driver_approved_reason != null) ?
                  <span className="alert-info reason-block">Approved Driver Reason : {this.state.data.driver_approved_reason}</span>
                  : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="wage-details-wage-approval-status-container">
                {(this.state.data.driver_approved == 1 &&
                  this.state.data.accountant_approved == 1) ?

                  (this.state.data.wage_paid == 0) ?
                    <p>
                      <input type="text"
                        name="wage_paid_reference" placeholder="Wage paid reference"
                        className="form-control form-control-lg"
                      />
                      <button className="btn btn-lg btn-primary"
                        onClick={(e) => { this.handleSetWageAsPaidButtonClicked() }}
                      >
                        <i className="fa fa-double-check"></i> Set DriverWage as paid
                      </button>
                    </p>
                    :
                    <p>
                      <button className="btn btn-lg btn-success">
                        <i className="fa fa-check-double"></i> Driver Wage Paid
                      </button>
                      <input type="text"
                        name="wage_paid_reference" value={this.state.data.wage_paid_reference}
                        placeholder="Wage paid reference"
                        className="form-control form-control-lg"
                      />
                    </p>

                  :
                  <strong>Waiting for Driver Approval</strong>
                }
              </div>
            </div>
          </div>

        </div>
      }
    </div>)
  }

  setWageAsPaid() {
    var that = this;
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/set-as-paid',
        data: {
          api_token: window.api_token,
          wage_paid_reference: $(
            '#driver-wage-'+this.state.data.id+' [name=wage_paid_reference]').val()
        },
        cache: false,
        method: 'post',
      })
      .done(function(wageJson) {
        that.setState({data: wageJson, isLoading: false});
        //auto refresh selected month week boxes
        if(that.state.data.driver_wage_account_id, that.state.data.calendar_month, that.state.data.calendar_year){
          that.props.getDriverWagesForMonth(that.state.data.calendar_month, that.state.data.calendar_year,true);
        }
      });
  }

  calculateWage() {
    var that = this;
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/calculate/'+this.state.fromDate+'/'+this.state.toDate,
        data: {api_token: window.api_token},
        cache: false
      })
      .done(function(calculatedWageJson) {
        that.setState({data: calculatedWageJson, isLoading: false});
        //auto refresh selected month week boxes
        if(that.state.data.driver_wage_account_id, that.state.data.calendar_month, that.state.data.calendar_year){
          that.props.getDriverWagesForMonth(that.state.data.calendar_month, that.state.data.calendar_year,true);
        }
      });
  }

  approveWage() {
    var that = this;
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/approve',
        data: {api_token: window.api_token},
        cache: false,
        method: 'post',
      })
      .done(function(wageJson) {
        that.setState({data: wageJson, isLoading: false});
        //auto refresh selected month week boxes
        if(that.state.data.driver_wage_account_id, that.state.data.calendar_month, that.state.data.calendar_year){
          that.props.getDriverWagesForMonth(that.state.data.calendar_month, that.state.data.calendar_year,true);
        }
      });
  }

/**  
@deprecated
*/
handleTotalPayableToWages(totalPayable){
    totalPayable = (totalPayable * 100);
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/set-wage_total_payable',
        data: {api_token: window.api_token,wage_total_payable_in_pence:totalPayable},
        cache: false,
        method: 'post',
      })
      .done(function(wageJson) {
        //done
      });
  }

  setComponentRef = (ref) => {
    this.componentRef = ref;
  };

  reactToPrintContent = () => {
    return this.componentRef;
  };

  handleDriverApproveWageButtonClicked() {
    var that = this;
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/force-as-driver/approve',
        data: {api_token: window.api_token},
        cache: false,
        method: 'post',
      })
      .done(function(wageJson) {
        that.setState({data: wageJson, isLoading: false});
        //auto refresh selected month week boxes
        if(that.state.data.driver_wage_account_id, that.state.data.calendar_month, that.state.data.calendar_year){
          that.props.getDriverWagesForMonth(that.state.data.calendar_month, that.state.data.calendar_year,true);
        }
      });
  }
  render() {
    return (
      <div>
        <ReactToPrint
          content={this.reactToPrintContent}
          documentTitle={document.getElementById('driver-wage-details-modal-label').innerText}
          onAfterPrint={this.handleAfterPrint}
          removeAfterPrint
        >
          <PrintContextConsumer>
            {({ handlePrint }) => (
              <button id="driver-wage-details-print" className="d-none" onClick={handlePrint}>Print Page</button>
            )}
          </PrintContextConsumer>
        </ReactToPrint>
        {this.renderDriverInvoice(this.setComponentRef)}
      </div>
    );
  }
}
